import { render, staticRenderFns } from "./backmsg.vue?vue&type=template&id=5f883b8d&scoped=true&"
import script from "./backmsg.vue?vue&type=script&lang=js&"
export * from "./backmsg.vue?vue&type=script&lang=js&"
import style0 from "./backmsg.vue?vue&type=style&index=0&id=5f883b8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f883b8d",
  null
  
)

export default component.exports